export default "__VITE_ASSET__XEsHqe9a__"